// extracted by mini-css-extract-plugin
module.exports = {"center":"reset-password_center__2POYy","content":"reset-password_content__1tFQR"};